import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { kycApi } from '@/api/kyc';
import { DocRequestView } from '@/components';
import { useDispatch, useSelector } from 'react-redux';
import { investorApi } from '@/api';
import { userActions } from '@/store/user';
import { getErrorMessage } from '@/utils/helpers';
import { useLoadingState } from '@/hooks';

export const DocumentRequest = ({ referralView = false }) => {
  const { referralToken } = useSelector((state) => state.user);
  const { id, referralId } = useParams();
  const dispatch = useDispatch();
  const { data, refetch, isFetching } = useQuery({
    queryKey: ['getDocument', referralToken],
    queryFn: () =>
      referralView
        ? kycApi.getReferralDocumentRequest(referralToken, id)
        : kycApi.getDocumentRequest(id),
    enabled: (referralView && !!referralToken) || !referralView
  });
  const [error, setError] = useState(undefined);

  useLoadingState(isFetching, 'Loading');

  useEffect(() => {
    if (id && !referralToken && referralView && referralId) {
      (async () => {
        try {
          const res = await investorApi.getReferralToken(referralId);

          if (res) {
            dispatch(userActions.setReferralToken(res.data.accessToken));
            if (error) setError(undefined);
          }
        } catch (e) {
          setError(getErrorMessage(e));
        }
      })();
    }
  }, [id, referralToken, referralView, referralId]);

  return (
    <DocRequestView
      isFetching={isFetching}
      data={data}
      refetch={refetch}
      requestId={id}
      referralView={referralView}
    />
  );
};
